module.exports = __webpack_public_path__ + "img/0x4792C1EcB969B036eb51330c63bD27899A13D84e.b2914932.png";